var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_5b9c855c"]},_vm.$listeners),[_c('div',[_c('div',{class:["picker-demo-title"]},[_vm._v("Use format:")]),_c('cube-date-picker',{attrs:{"min":(_vm.min),"max":(_vm.max),"value":(_vm.value),"format":(_vm.format)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }